import { render, staticRenderFns } from "./OrphanClaims.vue?vue&type=template&id=1b9d48c0"
import script from "./OrphanClaims.vue?vue&type=script&lang=js"
export * from "./OrphanClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports